import { Component, OnDestroy, AfterViewInit} from '@angular/core'
import { Router } from '@angular/router'

import { appStateProvider } from '../../../insa-providers'
import {AuthService, LocalizeService, TaskListService } from '../../../insa-services'
import { TaskModel, UserAccountDataModel } from '../../../insa-models';

@Component({
    selector: 'task-list-widget',
    templateUrl: 'taskList.component.html'
})

export class TaskList implements OnDestroy, AfterViewInit {
    private today = new Date();
    private weekAgo = new Date(new Date().setDate(this.today.getDate() - 7));
    private complete_id = "complete-chkbx-id";
    private isPrivate = false;
    private taskText = "";
    private taskList: TaskModel[] = [];
    private taskListFiltered = [];
    private editedTask: TaskModel;
    private newTask: TaskModel;
    private usersList: UserAccountDataModel[] = [];
    private selectedUserID: number;
    private editingTaskIndex: number;
    // filter flags to override default behavior of list
    private filters = {
      new: false, // // default: show both; if true only last 7 days are shown
      onlyCompleted: false, // default: hide completed tasks
      unassigned: false, // default: show both; if true only unassigned are shown
      overdue: false // default: show both; if true only overdue are shown
    };
    private hasFilters = false;
    private metadataName:string = "TaskList"

    constructor(private _taskListService: TaskListService, private _authService: AuthService, private _appStateProvider: appStateProvider, private _router: Router, private _localize: LocalizeService){
      this.ResetNewTask();
    }

    initDatePickers() {
      let pickersAnimation: kendo.ui.DatePickerAnimation = {};
      pickersAnimation.close = {};
      pickersAnimation.close.duration = 300;
      pickersAnimation.close.effects = "fadeOut zoom:out";
      pickersAnimation.open = {};
      pickersAnimation.open.duration = 300;
      pickersAnimation.open.effects = "fadeIn zoom:in";

      let pickerOptions: kendo.ui.DatePickerOptions = {};
      pickerOptions.animation = pickersAnimation;
      pickerOptions.format = "dd.MM.yyyy";
      pickerOptions.min = new Date(this.today.getFullYear(), 1, 1);
      pickerOptions.value = null;
      pickerOptions.culture = this._localize.getLocale(); 

      $("#DueDatePicker").kendoDatePicker(pickerOptions);
  }
  
  GetDatePickerValue() {
    return $("#DueDatePicker").data("kendoDatePicker").value();
  }

  UpdateDatePickerValue() {
    $("#DueDatePicker").data("kendoDatePicker").value(this.editedTask.DueDate);
  }

  FilterBy (filterType) {
    // if filter is null then reset to default
    if (filterType === null) {
      Object.keys(this.filters).forEach(k => {
        this.filters[k] = false;
      })
    } else {
      // toggle filter
      this.filters[filterType] = !this.filters[filterType]
    }
    // refresh filtered list
    this.FilterTaskList();
  }
  

    ResetNewTask () {
      this.newTask = {
          TaskID: null,
          Text: '',
          UserID: null,
          DateAppointed: null,
          DateCompleted: null,
          IsPrivate: false,
          AssignedUserID: null,
          DueDate: null,
          PartnerNumber: '',
          PortfolioNumber: ''
      };
      this.editedTask = this.newTask;
    }

    //holi
    /*AddTask() {
        this.editingTaskIndex = undefined;
        this.newTask.DateAppointed = new Date();
        this._taskListService.createTask(this.newTask).subscribe(
            taskData => {
                this.taskList.push(taskData);
                this.FilterTaskList();
                this.ResetNewTask();
                $(".taskListContainer").animate({ scrollTop: $('.taskListContainer').prop("scrollHeight")}, 1000);
            })

    }*/

    
    // holi
    /*GetTaskList() {
        this._taskListService.getTaskList().subscribe(
            taskData => {
                taskData.forEach(t => {
                  // fix date fields
                  t.DueDate = t.DueDate ? new Date(Date.parse(t.DueDate)) : null;
                  t.DateAppointed = t.DateAppointed ? new Date(Date.parse(t.DateAppointed)) : null;
                  t.DateCompleted = t.DateCompleted ? new Date(Date.parse(t.DateCompleted)) : null;
                });
                this.taskList = taskData;
                this._taskListService.getUsers().subscribe(
                  usersData => {
                    this.usersList = usersData;
                    this.FilterTaskList();
                })
            }
        )
    }*/

    FilterTaskList () {
      this.hasFilters = Object.keys(this.filters).some(k => this.filters[k]);
      this.taskListFiltered = this.taskList.filter(t => {
        let isOk = {};
        Object.keys(this.filters).forEach(k => {
          isOk[k] = true;
        })
        // new compare created date to week ago
        if (this.filters.new) {
          isOk['new']  = t.DateAppointed !== null && (t.DateAppointed > this.weekAgo);
          // console.log(`${t.Text}: ${t.DateAppointed} > ${this.weekAgo} = ${isOk['new']}`)
        }
        // hide completed by default
        if (t.DateCompleted !== null) {
          isOk['onlyCompleted'] = false;
        }
        // exception is made when we show completed
        if (this.filters.onlyCompleted) {
          isOk['onlyCompleted'] = t.DateCompleted !== null;
        }
        // if we filter unassigned, we remove all which have ID
        if (this.filters.unassigned) {
          isOk['unassigned'] = t.AssignedUserID === null;
        }
        // overdue compare to today but also cover case for overdue completed
        if (this.filters.overdue) {
          isOk['overdue']  = t.DueDate !== null && (t.DueDate < this.today || (t.DateCompleted && t.DueDate < t.DateCompleted));
        }
        // return true only if all isOk
        return Object.keys(isOk).every(k => isOk[k]);
      })
    }

    GetUserById (userId) {
      let uu = this.usersList.find(u => userId === u.ID)
      if (!uu) {
        return {
          FullName: '[unassigned]'
        }
      }
      return uu;
    }

    // holi
    /* ClickToCompleteTask(index: number) {
      // toggle date completed
      if (this.taskListFiltered[index].DateCompleted === null) {
        this.taskListFiltered[index].DateCompleted = new Date();
      } else {
        this.taskListFiltered[index].DateCompleted = null;
      }
      this.SaveTask(index);
    }*/

    CanEdit (task) {
      // only creator can edit the task - uncomment rest if the assigned person can change it
      let can =  task.UserID === this._authService.UserInfo.UserID; // || this._authService.UserInfo.UserID ===  task.AssignedUserID;
      // console.log(`CanEdit ${task.Text} by ${this._authService.UserInfo.UserID}: ${can} (${task.UserID} -> ${task.AssignedUserID})`)
      return can;// || task.AssignedUserID === null;
    }

    EditTask(index: number) {
      let task = this.taskListFiltered[index];
      if (this.CanEdit(task)) {
        this.editingTaskIndex = index;
        this.editedTask = this.taskListFiltered[index];
      }
    }

    
    // holi
    /*SaveTask (index: number) {
        // we use nextTick in order to allow Angular to go through with check/uncheck logic and data binding
        // TODO: there was an issue so we added it, but I don't know if it's needed anymore after refactoring
        process.nextTick(() => {
          let taskToUpdate = this.taskListFiltered[index];
          this._taskListService.updateTask(taskToUpdate).subscribe(
            taskData => {
                taskData.DateAppointed = taskData.DateAppointed ? new Date(Date.parse(taskData.DateAppointed)) : null;
                taskData.DateCompleted = taskData.DateCompleted ? new Date(Date.parse(taskData.DateCompleted)) : null;
                taskData.DueDate = taskData.DueDate ? new Date(Date.parse(taskData.DueDate)) : null;
                Object.assign(taskToUpdate, taskData);
                this.FilterTaskList();
                this.editingTaskIndex = undefined;
                this.ResetNewTask();
            })
      })
    }*/

    CancelSave () {
      this.editingTaskIndex = undefined;
      this.ResetNewTask();
    }

    ChangeAssignedUser(index: number) {
      if (this.CanEdit(this.taskListFiltered[index])) {
        this.editingTaskIndex = index;
        this.editedTask = this.taskListFiltered[index];
        this.selectedUserID = this.editedTask.AssignedUserID;
        this.UpdateDatePickerValue();
        $('#taskModal').modal('show');
      }
    }

    // holi
    /*CloseUserAssignment() {
      // EDIT
      $('#taskModal').modal('hide');
      if (this.editedTask !== undefined) {
        // save the updated assignment
        this.editedTask.AssignedUserID = this.selectedUserID;
        this.editedTask.DueDate = this.GetDatePickerValue();
        this.SaveTask(this.editingTaskIndex);
      }
      // NEW: nothing to do
      // this.editingTaskIndex = undefined;
    }*/
    ngAfterViewInit() {
        this.initDatePickers();
        // this.GetTaskList();  holi
    }

    ngOnDestroy() {

    }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-main/insa-main-widgets/taskList.component.ts